import styled from '@emotion/styled'
import iconUser from '../../../../assets/images/icons-user-green-32-px.svg'
import iconAdd from '../../../../assets/images/icons-add-white-18-px.svg'
import Image from '../../../../components/common/Image'
import Text from '../../../../components/common/Text'
import RelativeCard from './RelativeCard'
import Button from '../../../../components/common/Button'
import { RelativeType } from '../../../../services/enrollment/enrollment-types'
import { mobile } from '../../../../utils/responsive-helper'
import { FONT_LIGHT_GRAY } from '../../../../constant/colors'
import Card from '../../../../components/common/Card'

const CustomStyleCard = styled(Card)`
  display: flex;
  /* position: relative; */
  flex-direction: column;
  width: 100%;
  padding: 32px;
  margin-bottom: 24px;
  ${mobile} {
    padding: 16px;
  }
`

const CardTopic = styled.div`
  justify-content: start;
  align-items: center;
  display: flex;
  flex-direction: row;
  width: 100%;
`

const IconStyle = styled.div`
  padding-right: 16px;
`

const ButtonCard = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
  width: 100%;
`

const ButtonInCardStyle = styled(Button)`
  width: 364px;
`

export type RelativeListProps = {
  relativeType?: RelativeType
  onClickAdd: () => void
  hidden: () => boolean
}

const RelativeList = (props: RelativeListProps) => {
  const { relativeType, onClickAdd, hidden } = props
  return (
    <CustomStyleCard>
      <CardTopic>
        <IconStyle>
          <Image src={iconUser} width={32} height={32} />
        </IconStyle>
        <Text size={24} type="Bold">
          {relativeType?.typeName}
        </Text>
      </CardTopic>
      <Text
        size={20}
        color={FONT_LIGHT_GRAY}
        style={{ justifyContent: 'start', display: 'flex', paddingTop: '16px' }}
      >
        {relativeType?.description}
      </Text>

      <RelativeCard
        typeName={relativeType?.typeName || ''}
        relativeInfo={relativeType?.relativeList || []}
      />
      <ButtonCard hidden={hidden()}>
        <ButtonInCardStyle onClick={onClickAdd}>
          <Image src={iconAdd} width={18} height={18} style={{ marginRight: '8px' }} />
          เพิ่ม{relativeType?.typeName}
        </ButtonInCardStyle>
      </ButtonCard>
    </CustomStyleCard>
  )
}

export default RelativeList
